export const fonts = {
  primary: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  secondary: "'Poppins', sans-serif",
};

export const colors = {
  primary1: '#00212d',
  primary2: '#00b056',
  secondary1: '#dbfb8e',
  secondary2: '#3a432c',
  secondary3: '#006693',
  white: '#ffffff',
  lightGray: '#f5f5f5',
  mediumGray: '#e0e0e0',
  darkGray: '#666666',
  textDark: '#363636',
  textMedium: '#666666',
  textLight: '#999999',
};